(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssq-brand-foundation"] && !Shopify.designMode) return;
  try {
    
  const normalizeSsquishyHomeHeading = () => {
    if (!document.querySelector('#MainContent[data-template="index"]')) return;

    document.querySelectorAll('#header-group h1.visually-hidden').forEach((heading) => {
      const label = document.createElement('span');
      label.className = heading.className;
      label.textContent = heading.textContent;
      heading.replaceWith(label);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeSsquishyHomeHeading, { once: true });
  } else {
    normalizeSsquishyHomeHeading();
  }

  } catch(e) { console.error(e); }
})();
})();
